<template>

    <div class="scrolltable">

        <div class="scrolltable__wrapper" >

            <v-toolbar v-if="toolbar" dense dark color="secondary">

              <v-toolbar-title class="subtitle-2 back--text text-uppercase">
                <span class="body-2 text-uppercase">{{ $t(toolbar) }}</span>
              </v-toolbar-title>

            </v-toolbar>

            <table class="scrolltable__container">

                <thead v-if="!header" class="scrolltable__header" :class="{ 'scrolltable__scroll': scroll.visible }">

                    <tr class="scrolltable__row scrolltable__header-row" :style="rowStatus ? `margin-right: 0px;` : `margin-right: 0px; border-bottom: solid 1px #ddd; padding-left: ${subscribed ? '20px' : '0px'}`" >

                        <th v-for="(item, index) in data.columns" :key="'header-cell-content-' + index" class="scrolltable__cell scrolltable__header-cell" :class="'scrolltable__cell_align_' + (item.align || 'center')" :style="item.width ? 'flex-basis: ' + item.width : 'flex-basis: ' + getOptions(item.type).width">

                          <v-flex shrink v-if="index == 0 && button.emit">

                            <v-tooltip dark color="secondary" left>
                              <v-btn :data-testid="$options.name + 'v-btn' + 'emit'" icon slot="activator" small dark :color="button.color" @click="() => {$emit(button.emit)}">
                                <v-icon small>{{ button.icon }}</v-icon>
                              </v-btn>
                              <span >{{$t(button.tooltip)}}</span>
                            </v-tooltip>

                          </v-flex>

                          <v-flex shrink v-if="index == 0 && addButton" style="position: relative">

                            <v-tooltip dark color="secondary" left>
                              <v-btn :data-testid="$options.name + 'v-btn' + 'emit-addForeign'" icon slot="activator" small color="accent" @click="() => {$emit('addForeign')}">
                                <v-icon small>add</v-icon>
                              </v-btn>
                              <span>{{$t('add foreign measurement')}}</span>
                            </v-tooltip>

                          </v-flex>

                          <v-flex shrink v-if="index == 0 && reload">

                            <v-tooltip dark color="secondary" left>
                              <v-btn :data-testid="$options.name + 'v-btn' + 'emit-reload'" icon small color="transparent" slot="activator" light text @click.stop="() => {$emit('reload')}" >
                                <v-icon color='green'>sync</v-icon>
                              </v-btn>
                              <span>{{$t('reload')}}</span>
                            </v-tooltip>

                          </v-flex>

                          <v-flex xs12 class="scrolltable__header-cell-content dark" style="text-align: justify;"  px-2>

                                <v-layout fill-height align-center>
                                  <span v-if="headTranslate" class="body-1 blacktext--text" :class="headUppercase ? 'text-uppercase' : ''">{{ $t(item.title) }}</span>
                                  <span v-if="!headTranslate" class="body-1 blacktext--text" :class="headUppercase ? 'text-uppercase' : ''">{{ item.title }}</span>

                                  <v-btn :data-testid="$options.name + 'v-btn' + 'sortTable-item'" v-if="sortable" class="my-0 mx-1" small icon @click.stop="() => sortTable(item)">
                                      <v-icon v-if="item.value == sorted" color='red'>keyboard_arrow_up</v-icon>
                                      <v-icon v-if="item.value == sorted.substring(1)" color='red'>keyboard_arrow_down</v-icon>
                                      <v-icon v-if="item.value != sorted.substring(1) && item.value != sorted" color='blacktext'>keyboard_arrow_down</v-icon>
                                  </v-btn>

                                  <v-tooltip dark color="secondary" bottom>
                                    <v-btn :data-testid="$options.name + 'v-btn' + 'onClick-updateMeasures'" small v-if="item.save && saveButton" color="primary" slot="activator" light text @click.stop="() => onClick('updateMeasures')" >{{$t('save changes')}}</v-btn>
                                    <span>{{ $t('save changes') }}</span>
                                  </v-tooltip>

                                  <v-tooltip dark color="secondary" bottom>
                                    <v-btn :data-testid="$options.name + 'v-btn' + 'onClick-manualSync'" icon small v-if="manualSyncButton && item.title == 'status'" color="transparent" slot="activator" light text @click.stop="() => onClick('manualSync')" >
                                      <v-icon color='warning'>sync</v-icon>
                                    </v-btn>
                                    <span>{{ $t('manual synchronization') }}</span>
                                  </v-tooltip>
                                </v-layout>

                          </v-flex> 

                        </th>

                        <th v-if="removable && data.columns.length" class="scrolltable__cell scrolltable__header-cell" :class="'scrolltable__cell_align_center'" :style="'flex-basis: 10%'">

                          <v-flex xs12 px-2>

                            <v-subheader class="scrolltable__header-cell-content pl-3">

                                <span class="text-uppercase blacktext--text">{{ $t('actions') }}</span>

                            </v-subheader>

                          </v-flex>

                        </th>

                    </tr>

                </thead>

                <tbody ref="body" class="scrolltable__body" :class="{ 'text_select': textSelect, 'scrolltable__scroll': scroll.visible, 'scrolltable__gradient-bottom': scroll.reached.bottom }" @scroll="onScroll">

                    <tr v-if="header" class="scrolltable__row scrolltable__header-row" :style="noTableRow ? '' : 'display: table-row'"  style="position: sticky; top: 0; z-index: 1">
                      <v-layout px-2>
                        <th v-for="(item, index) in data.columns" :key="'header-cell-content-' + index" class="scrolltable__cell scrolltable__header-cell" :class="'scrolltable__cell_align_' + (item.align || 'center')" :style="item.width ? 'flex-basis: ' + item.width : 'flex-basis: ' + getOptions(item.type).width">                  
                          <span v-if="headTranslate" class="body-1 text-uppercase">{{ $t(item.title) }}</span>
                          <span v-if="!headTranslate" class="body-1 text-uppercase">{{ item.title }}</span>
                          <v-btn :data-testid="$options.name + 'v-btn' + 'sortTable-item'" v-if="sortable" class="my-0 mx-1" small icon @click.stop="() => sortTable(item)">
                            <v-icon v-if="item.value == sorted" color='red'>keyboard_arrow_up</v-icon>
                            <v-icon v-if="item.value == sorted.substring(1)" color='red'>keyboard_arrow_down</v-icon>
                            <v-icon v-if="item.value != sorted.substring(1) && item.value != sorted">keyboard_arrow_down</v-icon>
                          </v-btn>
                        </th>
                      </v-layout>
                    </tr>

                    <tr v-for="(row, index) in getRows" :key="'body-row-' + index"  class="scrolltable__row scrolltable__body-row" :style="`border-bottom: solid 1px #ddd; margin-right: 0px; background-color: ${getClass(row)}; padding-left: ${subscribed && rowStatus ? '20px' : '0px'};`">
                      
                      <v-layout
                        @click.stop="() => {rowclick ? onClick('select', row) : ''}"
                        :class="hover ? 'body-row-hover' : 'body-row'"
                      >

                        <td v-for="(item, tdindex) in data.columns"
                          @click="() => onClick('value', row, item)"
                          :key="'header-cell-content-' + tdindex"
                          class="scrolltable__cell scrolltable__body-cell"
                          :class="'scrolltable__cell_align_center'"
                          :style="item.width ? 'flex-basis: ' + item.width : 'flex-basis: ' + getOptions(item.type).width">

                            <v-flex
                              v-if="tdindex == 0 && !subscribed && reload"
                              shrink
                              :style="'padding: 0 20px'"
                            >
                              
                            </v-flex>

                            <v-layout fill-height align-center justify-center v-if="item.type == 'text'" class="scrolltable__cell-content no-overflow nowrap" :style="item.cursor ? 'cursor: ' + item.cursor : 'cursor: '+ rowCursor" px-2>
                              
                              <v-layout shrink v-if="item.actions" justify-center-- align-center class="scrolltable__cell-content no-overflow nowrap ellipsis">
                                <v-tooltip v-for="(action, i) in item.actions" :key="'action_' + i"  dark color="secondary" bottom>
                                  <v-btn :data-testid="$options.name + 'v-btn' + 'emit'" slot="activator" class="my-0 mx-1" small icon @click.stop="() => {$emit(action.emit, row, item)}">
                                    <svg-icon
                                      :color='action.color ? action.color : getClass(row)'
                                      :name="action.icon"
                                      width="14"
                                    />
                                  </v-btn>
                                  
                                  <span v-if="action.title">{{ $t(action.title) }}</span>
                                  <span v-else>{{ $t(String(getRowValue(row, item))) }}</span>
                                  
                                </v-tooltip>

                                <v-layout v-if="item.fabIcon"  align-center justify-center>
                                  <v-tooltip v-if="index == 0" dark color="secondary" bottom>
                                  <v-btn :data-testid="$options.name + 'v-btn' + 'onClick-itemfabIconemitrowitem'"
                                      v-if="index == 0"
                                      slot="activator" 
                                      :color='item.fabIcon.color'
                                      dark
                                      small
                                      absolute
                                      right
                                      fab
                                      style="top: 38%"
                                      @click.stop="() => onClick(item.fabIcon.emit, row, item)"
                                    >
                                      <svg-icon
                                        color='white'
                                        name="settings"
                                        width="28"
                                      />
                                    </v-btn>
                                    <span class="body-1">{{ $t(item.fabIcon.tooltip || item.fabIcon.title) }}</span>
                                  </v-tooltip>

                                </v-layout>

                                <v-layout v-if="translate && !item.noTranslate && item.title != 'name' && item.title != 'author'" column class="body-1" justify-center>
                                  {{ $t(String(getRowValue(row, item)))}}
                                </v-layout>
                                
                              </v-layout>

                              <v-layout v-else>
                                <v-layout v-if="translate && !item.noTranslate && item.title != 'name' && item.title != 'author'" column class="body-1" justify-center>
                                  {{ $t(String(getRowValue(row, item)))}}
                                </v-layout>

                                <v-layout v-else column justify-center class="body-1" pl-2>
                                  {{ String(getRowValue(row, item)) }}
                                </v-layout>
                              </v-layout>

                            </v-layout>

                            <v-flex v-if="item.type == 'number' " :style="item.cursor ? 'cursor: ' + item.cursor : 'cursor: '+ rowCursor" class="body-1" px-2>
                              {{ typeof getRowValue(row, item) == 'number' ?  parseFloat(getRowValue(row, item).toFixed(3)) : getRowValue(row, item) }}
                            </v-flex>

                            <v-flex v-if="item.type == 'color'" class="scrolltable__cell-content no-overflow nowrap ellipsis" :style="item.cursor ? 'cursor: ' + item.cursor : 'cursor: '+ rowCursor" pa-0>

                              <v-layout column>

                                <v-tooltip dark color="secondary" left>
                                  <v-btn :data-testid="$options.name + 'v-btn' + 'remove'" small block slot="activator" :style="'background-color: ' + getRowValue(row, item)" text @click.stop="">{{ $t(getRowValue(row, item)) }}</v-btn>
                                  <span>{{ $t(getRowValue(row, item)) }}</span>
                                </v-tooltip>

                              </v-layout>

                            </v-flex>

                            <v-flex v-if="item.type == 'endpoint'" @click="() => {$emit('select', row)}" :style="item.cursor ? 'cursor: ' + item.cursor : 'cursor: '+ rowCursor" pa-0>
                                <span>{{getRowValue(row, item)}}</span>
                            </v-flex>

                            <v-flex v-if="item.type == 'endpoint_subscrybed'" class="scrolltable__cell-content no-overflow" pa-0>

                              <v-layout v-if="Array.isArray( getRowValue(row, item))" column v-for="(obj, index) in getRowValue(row, item)" :key="index">
                                <v-layout align-center justify-space-between>
                                  <v-layout column>
                                    <span :style="`color: ${$getColor($store.state.monitoring.status[obj.obj.$id])}`">{{ obj.path }}</span>
                                  </v-layout>

                                </v-layout>
                              </v-layout>

                            </v-flex>

                            <v-flex v-if="item.type == 'crumbs'" class="body-1 scrolltable__cell-content no-overflow nowrap" :style="item.cursor ? 'cursor: ' + item.cursor : 'cursor: '+ rowCursor" pa-0>
                              <span class="blacktext--text">{{ getRowValue(row, item) }}</span>
                            </v-flex>

                            <v-flex v-if="item.type == 'content_logical'" :style="item.cursor ? 'cursor: ' + item.cursor : 'cursor: '+ rowCursor" pa-0>
                              <span>{{ row.content }}</span>
                            </v-flex>

                            <v-flex v-if="item.type == 'check' && getRowValue(row, item)" class="scrolltable__cell-content no-overflow nowrap ellipsis" :style="item.cursor ? 'cursor: ' + item.cursor : 'cursor: '+ rowCursor">
                              <v-btn :data-testid="$options.name + 'v-btn' + 'remove'" small class="my-0" icon @click="">
                                  <svg-icon :name="getRowValue(row, item)" @click.stop="() => {activeActions ? onClick('measureOff', row) : ''}" color="#464646" width="20"/>
                              </v-btn>
                            </v-flex>

                                <v-layout v-if="item.type == 'check_box'"  justify-center align-center>
                                  <v-flex shrink>
                                    <v-checkbox :data-testid="$options.name + 'v-checkbox' + 'row.selected'" v-if="item.type == 'check_box'" small light color="secondary" v-model="row.selected" :disabled="item.disabled"  :style="item.cursor ? 'cursor: ' + item.cursor : 'cursor: '+ rowCursor">
                                    </v-checkbox>
                                  </v-flex>
                                </v-layout>

                            <v-flex v-if="item.type == 'check_dependence'" class="scrolltable__cell-content no-overflow nowrap ellipsis" :style="item.cursor ? 'cursor: ' + item.cursor : 'cursor: '+ rowCursor">
                              <v-btn :data-testid="$options.name + 'v-btn' + 'archiving/polling'" :ripple="false" v-if="item.title == 'archiving/polling'" small class="my-0" icon @click="">
                                  <v-icon v-if="getRowValue(row, item)" color="#464646" width="20">{{ 'mdi-database-outline' }}</v-icon>
                                  <v-icon v-else color="#464646" width="20">{{ 'mdi-database-off-outline' }}</v-icon>
                              </v-btn>

                              <v-btn :data-testid="$options.name + 'v-btn' + 'apply to status'" :ripple="false" v-if="item.title == 'apply to status'" small class="my-0" icon @click="">
                                  <v-icon v-if="getRowValue(row, item)" color="#464646" width="20">{{ 'mdi-eye-outline' }}</v-icon>
                                  <v-icon v-else color="#464646" width="20">{{ 'mdi-eye-off-outline' }}</v-icon>
                              </v-btn>

                              <v-btn :data-testid="$options.name + 'v-btn' + 'apply to connection'" :ripple="false" v-if="item.title == 'apply to connection'" small class="my-0" icon @click="">
                                  <v-icon v-if="getRowValue(row, item)" color="#464646" width="20">{{ 'mdi-timeline-plus' }}</v-icon>
                                  <v-icon v-else color="#464646" width="20">{{ 'mdi-timeline-minus' }}</v-icon>
                              </v-btn>
                            </v-flex>

                            <v-flex v-if="item.type == 'array'" class="scrolltable__cell-content no-overflow nowrap ellipsis" pa-0>
                              <v-layout column v-for="(arr, index) in getRowValue(row, item)" :key="arr + index" >
                                <span class="body-1">{{arr}}</span>
                              </v-layout>
                            </v-flex>

                            <v-layout fill-height v-if="item.type == 'timestamp'" align-center :justify-center="item.align && item.align == 'center'" class="scrolltable__cell-content no-overflow nowrap" :style="item.cursor ? 'cursor: ' + item.cursor : 'cursor: '+ rowCursor" px-2>
                                <span class="body-1" slot="activator">{{ getRowValue(row, item) | moment(item.time_format || "DD.MM.YYYY HH:mm:ss") }}</span>
                            </v-layout>

                            <v-layout v-if="item.type == 'status' && row.$id" justify-center class="scrolltable__cell-content no-overflow nowrap ellipsis" :style="item.cursor ? 'cursor: ' + item.cursor : 'cursor: '+ rowCursor">
                              <v-layout column>
                                {{ $t($store.getters.getStatus[row.$id]) }}
                              </v-layout>

                            </v-layout>

                            <v-layout v-if="item.type == 'actions'" justify-center class="scrolltable__cell-content no-overflow nowrap ellipsis" :style="item.cursor ? 'cursor: ' + item.cursor : 'cursor: '+ rowCursor">

                              <v-tooltip v-for="(action, i) in item.actions" :key="'action_' + i"  dark color="secondary" bottom>
                                <v-btn :data-testid="$options.name + 'v-btn' + 'onClick-actionemitrow'" v-if="row.data_type && row.data_type == 'number'"  slot="activator" class="my-0 mx-1" small icon @click.stop="() => onClick(action.emit, row)">
                                  <svg-icon
                                    :color='action.color'
                                    :name="action.icon"
                                    :width="action.size ? action.size : '17'"
                                  />
                                </v-btn>
        
                                <span class="body-1">{{ $t(action.tooltip || action.title) }}</span>
                              </v-tooltip>

                            </v-layout>
                            

                        </td>

                        <td
                          v-if="Object.keys(row).length && removable"
                          class="scrolltable__cell scrolltable__body-cell justify-center"
                          :class="'scrolltable__cell_align_center'"
                          :style="item.cursor ? 'cursor: ' + item.cursor : 'cursor: '+ rowCursor"
                          style="flex-basis: 10%"
                        >
                        
                          <v-tooltip dark color="secondary" left>

                            <v-btn :data-testid="$options.name + 'v-btn' + 'onClick-removerow'" slot="activator" small class=" my-0" icon @click.stop="() => onClick('remove', row)">
                                <v-icon color="grey">delete</v-icon>
                            </v-btn>

                            <span class="body-1">{{$t('remove')}}</span>

                          </v-tooltip>

                        </td>

                      </v-layout>

                    </tr>

                </tbody>

                <tfoot v-if="$slots['table-actions']" class="scrolltable__footer" :class="{ 'scrolltable__scroll': scroll.visible }">

                    <tr class="scrolltable__row scrolltable__footer-row">

                        <td colspan="5" class="scrolltable__cell scrolltable__footer-cell">

                            <v-card
                                class="flex"
                                flat
                                tile
                            >
                                <v-card-actions v-if="$slots['table-actions']">
                                    <v-spacer/>
                                    <v-btn :data-testid="$options.name + 'v-btn' + 'onClick-cancel'" @click.stop="() => onClick('cancel')" flat active-class class="no-transform font-weight-regular">Отменить</v-btn>
                                    <v-btn :data-testid="$options.name + 'v-btn' + 'onClick-save'" color="accept" class="no-transform" depressed @click.stop="() => onClick('save')">Сохранить</v-btn>
                                </v-card-actions>

                            </v-card>

                        </td>

                    </tr>

                </tfoot>

            </table>
        </div>
    </div>

</template>

<script lang="ts">
import Vue from 'vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'

// Типы для данных таблицы
interface TableColumn {
  title?: string
  value?: string
  width?: string
  noTranslate?: boolean
  lastArrayItem?: boolean
  [key: string]: any
}

interface TableRow {
  $id?: string
  state?: string
  status?: string
  hidden?: string
  value?: any
  ss?: { state?: string }
  labels?: { status?: string }
  data?: { status?: string }
  options?: { noState?: boolean }
  [key: string]: any
}

interface TableData {
  columns: TableColumn[]
  rows: TableRow[]
}

interface ButtonConfig {
  [key: string]: any
}

interface OptionsColumns {
  [key: string]: { width: string }
}

interface ScrollState {
  visible: boolean
  reached: {
    top: boolean
    bottom: boolean
  }
}

export default Vue.extend({
  
  name: 'SCROLLTABLE',

  components: {
    svgIcon,
  },

  props: {
    data: {
      type: Object as () => TableData,
      default: () => ({ columns: [], rows: [] })
    },
    toolbar: {
      type: String,
      default: () => null
    },
    subscribed: {
      type: Boolean,
      default: () => true
    },
    ownStatus: {
      type: Boolean,
      default: () => false
    },
    rowStatus: {
      type: Boolean,
      default: () => false
    },
    textSelect: {
      type: Boolean,
      default: () => true
    },
    hover: {
      type: Boolean,
      default: () => true
    },
    manualSyncButton: {
      type: Boolean,
      default: () => false
    },
    sortable: {
      type: Boolean,
      default: () => false
    },
    reverseRows: {
      type: Boolean,
      default: () => false
    },
    removable: {
      type: Boolean,
      default: () => false
    },
    resizable: {
      type: Boolean,
      default: () => false
    },
    sorted: {
      type: String,
      default: () => ''
    },
    rowCursor: {
      type: String,
      default: () => 'default'
    },
    rowclick: {
      type: Boolean,
      default: () => true
    },
    translate: {
      type: Boolean,
      default: () => false
    },
    headTranslate: {
      type: Boolean,
      default: () => true
    },
    headUppercase: {
      type: Boolean,
      default: () => true
    },
    header: {
      type: Boolean,
      default: () => false
    },
    noTableRow: {
      type: Boolean,
      default: () => true
    },
    saveButton: {
      type: Boolean,
      default: () => false
    },
    addButton: {
      type: Boolean,
      default: () => false
    },
    button: {
      type: Object as () => ButtonConfig,
      default: () => ({})
    },
    reload: {
      type: Boolean,
      default: () => false
    },
    activeActions: {
      type: Boolean,
      default: () => false
    },
    hideState: {
      type: Array as () => string[],
      default: () => []
    },
    hideValues: {
      type: Array as () => string[],
      default: () => []
    },
  },

  data(): { options: { columns: OptionsColumns }; scroll: ScrollState; width: (number | null)[] } {
    return {
      options: {
        columns: {
          text: { width: '40%' },
          timestamp: { width: '20%' },
          check: { width: '5%' },
          actions: { width: '20%' }
        },
      },
      scroll: {
        visible: false,
        reached: {
          top: false,
          bottom: false,
        },
      },
      width: []
    }
  },

  watch: {
    sortable: {
      handler(newVal: boolean): void {
        if (this.resizable) {
          if (!newVal) {
            this.removeColumnResize()
            return
          }
          this.resizableGrid()
        }
      },
      deep: true
    }
  },

  computed: {
    getData(): TableData {
      return this.data
    },

    getRowclick(): boolean {
      return this.rowclick
    },

    getRows(): TableRow[] {
      if (this.hideState.length) {
        const rows$ = this.data.rows.filter((row: TableRow) => {
          if (!this.hideState.includes(row.state || '')) {
            return true
          } else {
            const t = typeof row.value
            return (t === 'string' || t === 'number' || t === 'boolean')
          }
        }).filter((row: TableRow) => {
          if (row.hidden === 'false') return true
          if (row.hidden === 'trigger' && (row.state === 'alarm' || row.state === 'warning' || row.state === 'damage')) {
            return true
          }
          if (row.options?.noState && row.state === 'off') {
            return true
          }
          return false
        }) as TableRow[]
        
        return this.reverseRows ? [...rows$].reverse() : rows$
      } else {
        return this.reverseRows ? [...this.data.rows].reverse() : this.data.rows
      }
    },
  },

  created(): void {
    if (this.resizable) {
      this.createWidth()
    }
  },

  mounted(): void {
    this.setupScroll(this.$refs.body as HTMLElement)
  },

  updated(): void {
    this.setupScroll(this.$refs.body as HTMLElement)
  },

  beforeDestroy(): void {},

  methods: {
    getOptions(type: string): { width: string } {
      return this.options.columns[type] || { width: '20%' }
    },

    getRowValue(row: TableRow, item: TableColumn): any {
      const value = item.value || ''
      
      if (item.lastArrayItem && Array.isArray(row[value])) {
        const arr = row[value] as any[]
        const lastItem = arr[arr.length - 1]
        return this.translate && !item.noTranslate 
          ? this.$getTranslate(lastItem) 
          : lastItem
      }

      const val = value.split('.')
      let resp = ''
      let rowVal = row[value]
      
      if (this.translate && !item.noTranslate && Array.isArray(row[value])) {
        rowVal = []
        ;(row[value] as any[]).forEach((valItem: any) => {
          rowVal.push(this.$getTranslate(valItem))
        })
      }
      
      if (val && val.length > 1) {
        let v: any = row
        val.forEach((key: string) => {
          v = this.translate && !item.noTranslate ? this.$getTranslate(v[key]) : v[key]
        })
        resp = v
      } else {
        resp = rowVal
      }

      return this.hideValues.includes(String(resp)) ? '' : resp
    },

    splitString(str: string): string {
      return str.split('/').join(' / ')
    },

    onScroll(e: Event): void {
      const target = e.target as HTMLElement
      this.setupScroll(target)
    },

    setupScroll(element: HTMLElement): void {
      if (!element) return
      this.scroll.visible = element.scrollHeight > element.offsetHeight
    },

    getClass(row: TableRow): string {
      if (this.subscribed) {
        if (this.$store.state.books.statuses.length) {
          let status: string | undefined = undefined

          if (row.ss?.state) {
            status = row.ss.state
          } else if (row.state) {
            status = row.state
          } else if (row.status) {
            status = row.status
          } else if (this.$store.getters.getStatus[row.$id]) {
            status = this.$store.getters.getStatus[row.$id]
          }
          
          let color = this.$store.state.books.statuses.find((item: any) => item.name === status)
          
          if (!color) {
            color = this.$store.state.books.statuses.find((item: any) => item.name === 'unknown')
          }
          
          return color ? color.back_color : 'grey'
        }
        return 'white'
      } else {
        if (this.ownStatus) {
          if (this.$store.state.books.statuses.length) {
            let status: string | undefined = undefined

            if (row.status) {
              status = row.status
            } else if (row.labels?.status) {
              status = row.labels.status
            } else if (row.data?.status) {
              status = row.data.status
            }
            
            let color = this.$store.state.books.statuses.find((item: any) => item.name === status)
            
            if (!color) {
              color = this.$store.state.books.statuses.find((item: any) => item.name === 'unknown')
            }
            
            return color ? color.back_color : 'grey'
          }
          return 'white'
        } else {
          return 'white'
        }
      }
    },

    sortTable(item: TableColumn): void {
      this.$emit('sort', item)
    },

    onClick(name: string, row: TableRow, item?: TableColumn): void {
      console.log('SCROLLTABLE ONCLICK rowclick', this.getRowclick)
      console.log('SCROLLTABLE ONCLICK', name, row, item)

      if (name === 'archive') {
        this.$emit('confirm', { row, mode: 'archive' })
        return
      }
      if (name === 'measureOff') {
        this.$emit('confirm', { row, mode: 'archive' })
        return
      }
      if (name === 'chart') {
        this.$emit('chart', row)
        return
      }
      if (name === 'select') {
        this.$emit('select', row, item)
        return
      }
      if (name === 'manualSync') {
        this.$emit('manualSync')
        return
      }
      if (name === 'value') {
        if (this.rowclick) {
          this.$emit('value', row, item)
        } else {
          this.$emit(item?.title || name, row)
        }
        return
      }
      
      this.$emit(name, row)
    },

    createWidth(): void {
      this.getData.columns.forEach((_, index: number) => {
        this.$set(this.width, index, null)
      })
      console.log('CREATE_WIDTH', this.width)
    },

    removeColumnResize(): void {
      const table = document.getElementsByClassName('scrolltable__container')[0] as HTMLElement
      if (!table) return
      const divs = table.getElementsByClassName('divForColumnResize')
      while (divs.length > 0) {
        divs[0].remove()
      }
    },

    resizableGrid(): void {
      const table = document.getElementsByClassName('scrolltable__container')[0] as HTMLElement
      if (!table) return
      
      const rows = table.getElementsByTagName('tr')
      const cols = rows && rows[0] ? rows[0].children : undefined
      if (!cols) return
      
      table.style.overflow = 'hidden'
      const tableHeight = rows[0].offsetHeight
      
      for (let i = 0; i < cols.length; i++) {
        const div = this.createDiv(tableHeight)
        cols[i].appendChild(div)
        ;(cols[i] as HTMLElement).style.position = 'relative'
        this.setListeners(div, i)
      }
    },

    createDiv(height: number): HTMLElement {
      const div = document.createElement('div')
      div.style.top = '0'
      div.style.right = '0'
      div.style.width = '10px'
      div.style.position = 'absolute'
      div.style.cursor = 'col-resize'
      div.style.userSelect = 'none'
      div.style.height = height + 'px'
      div.className = 'divForColumnResize'
      return div
    },

    setListeners(div: HTMLElement, index: number): void {
      let pageX: number, curCol: HTMLElement | undefined, nxtCol: HTMLElement | undefined
      let curColWidth: number, nxtColWidth: number
      
      const mouseDownHandler = (e: MouseEvent) => {
        curCol = (e.target as HTMLElement).parentElement as HTMLElement
        nxtCol = curCol.nextElementSibling as HTMLElement
        pageX = e.pageX
        const padding = this.paddingDiff(curCol)
        curColWidth = curCol.offsetWidth - padding
        if (nxtCol) {
          nxtColWidth = nxtCol.offsetWidth - padding
        }
        document.addEventListener('mouseup', mouseUpHandler)
        document.addEventListener('mousemove', mouseMoveHandler)
      }
      
      const mouseOverHandler = (e: MouseEvent) => {
        (e.target as HTMLElement).style.borderRight = '5px solid #f7941d'
      }
      
      const mouseUpHandler = () => {
        curCol = undefined
        nxtCol = undefined
        document.removeEventListener('mousemove', mouseMoveHandler)
        document.removeEventListener('mouseup', mouseUpHandler)
      }
      
      const mouseOutHandler = (e: MouseEvent) => {
        (e.target as HTMLElement).style.borderRight = ''
      }
      
      const mouseMoveHandler = (e: MouseEvent) => {
        if (curCol) {
          const diffX = e.pageX - pageX
          
          if (nxtCol) {
            nxtCol.style.width = (nxtColWidth - diffX) + 'px'
            this.$set(this.width, index + 1, nxtColWidth - diffX)
          }
          curCol.style.width = (curColWidth + diffX) + 'px'
          this.$set(this.width, index, curColWidth + diffX)
        }
      }
      
      div.addEventListener('mousedown', mouseDownHandler)
      div.addEventListener('mouseover', mouseOverHandler)
      div.addEventListener('mouseout', mouseOutHandler)
    },

    paddingDiff(col: HTMLElement): number {
      const getStyleVal = (elm: HTMLElement, css: string): string => {
        return window.getComputedStyle(elm, null).getPropertyValue(css)
      }
      
      if (getStyleVal(col, 'box-sizing') === 'border-box') {
        return 0
      }
      
      const padLeft = getStyleVal(col, 'padding-left')
      const padRight = getStyleVal(col, 'padding-right')
      return (parseInt(padLeft) + parseInt(padRight))
    },
  },
})
</script>

<style scoped lang="stylus">

    ::-webkit-scrollbar
      width: 4px;


    ::-webkit-scrollbar-track
      /* -webkit-box-shadow: inset 0 0 4px #1E4972; */
      /* -webkit-box-shadow: inset 0 0 4px #c2c2c2; */
      /* -webkit-box-shadow: inset 0 0 4px #F7941D; */
      -webkit-box-shadow: inset 0 0 4px rgba(0,0,0,0.3);
      border-radius: 4px;

    ::-webkit-scrollbar-thumb
      border-radius: 10px;
      /* -webkit-box-shadow: inset 0 0 4px '#1E4972'; */
      /* -webkit-box-shadow: inset 0 0 4px #c2c2c2; */
      /* -webkit-box-shadow: inset 0 0 4px #F7941D; */
      -webkit-box-shadow: inset 0 0 4px rgba(0,0,0,0.8);

    .text_select

      user-select: text
      -moz-user-select: text
      -webkit-user-select: text

    .body-row

      background-color: #ffffff

    .body-row-hover

      background-color: #ffffff

      &:hover

        background-color: #CDEBF9
        /* background-color: #6CACE4 */

    .scrolltable

      position: relative

      width: 100%
      height: 100%

      &__wrapper

          position: absolute

          

          top: 0
          right: 0
          bottom: 0
          left: 0

          overflow: hidden

      &__container

          display: flex
          flex-direction: column
          flex: 1 1 auto

          width: 100%
          height: 100%

          border-collapse: collapse
          overflow: hidden

          /*
              Use this to create a "dead" area color
              if table is too wide for cells
              background-color: #ccc;
          */

      &__header

          /*
            Grow thead automatically to fit content, don't shrink it
            proportionately to the body.
          */
          flex: 0 0 auto
          display: block

          /*
              x-scrolling will be managed via JS
          */

          /*
              For Webkit, use "dead area" color to hide scrollbar functions
              TODO: on Chrome/Safari for Mac, scrollbars are not shown anyway and
              this creates an extra block. No impact on iOS Safari.
          */
          /*
              thead::-webkit-scrollbar { display: block; background-color: #ccc; }
              thead::-webkit-scrollbar-track { background-color: #ccc; }
          */

          /*
              thead::-webkit-scrollbar { display: block; background-color: #f7f7f7; }
              thead::-webkit-scrollbar-track { background-color: #f7f7f7; }
          */

      &__footer

          /*
              Grow thead automatically to fit content, don't shrink it
              proportionately to the body.
          */
          flex: 0 0 auto
          display: block

          /*
              x-scrolling will be managed via JS
          */
          overflow-x: hidden


          /*
              For Webkit, use "dead area" color to hide scrollbar functions
              TODO: on Chrome/Safari for Mac, scrollbars are not shown anyway and
              this creates an extra block. No impact on iOS Safari.
          */
          /*
              thead::-webkit-scrollbar { display: block; background-color: #ccc; }
              thead::-webkit-scrollbar-track { background-color: #ccc; }
          */

          /*
              thead::-webkit-scrollbar { display: block; background-color: #f7f7f7; }
              thead::-webkit-scrollbar-track { background-color: #f7f7f7; }
          */

      &__body

          overflow: auto

          /* background-color: #f7f7f7; */
          background-color: #ffffff
          flex: auto

          /* IE11 adds an extra tbody, have to hide it */
          &:nth-child(3)

              display: none

      &__gradient-bottom

          -webkit-mask-image: -webkit-gradient(linear, left 90%, left bottom, from(rgba(0, 0, 0, 1)), to(rgba(0, 0, 0, 0)))

      &__row

          display: flex
          flex-direction: row
          justify-content: space-between

          &:nth-child(odd)

              background-color: #E1E1E1

          &:nth-child(even)

          /* background-color: #f2f2f2 */
              background-color: #E1E1E1

          &:last-of-type

              .scrolltable__cell

                  border-bottom: medium none


      &__header-row
          max-height: 82px

          &:last-of-type

              .scrolltable__cell

                  border-bottom: 1px solid #ddd

      /* The one caveat, a hard-set width is required. */
      &__cell

          display: flex
          /* background-color: #ffffff */
          word-wrap: break-word

          flex: 1 1 100%
          /* flex: 1 1 100% */
          /* align-items: center */
          align-items: start

          /* min-width: 10em */
          min-width: 100px
          padding: 2px
          word-wrap: break-word

          /* border-right: 1px solid #ddd */
          /* border-bottom: 1px solid #ddd */
          
          border-collapse: collapse
          box-sizing: border-box

          &:last-of-type

          /* border-right: medium none */
              
          &_align

              &_left

                  justify-content: flex-start

              &_center

                  justify-content: center

              &_right

                  justify-content: flex-end;

      &__header-cell

          display: flex
          align-items: start
          /* align-items: center */
          /* background-color: #ffffff */
          max-height: 82px
          /* padding: 0 */
          padding: 8px 8px


      &__footer-cell

          /* padding: 0 */
          padding: 8px 8px
          border-top: 1px solid #ddd

</style>
